
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue'; 
    
    @Component({
        components: { VWidget },
    })

    export default class ThermometerStats extends ListBase {
        options: any = {
            text: {
                color: 'black',
                fontSize: 10,
                textAdjustmentY: 2,
                fontFamily: 'Arial',
                textEnabled: true
            },
            thermo: {
                color: '#FF0000',
                backgroundColor: '#fcf9f9',
                frameColor: 'black',
                ticks: 10,
                ticksEnabled: true,
                tickColor: 'black',
                tickWidth: '1'
            },
            layout: {
                height: 200,
                width: 90
            }
        };

        get list() {
            let list = [];
            this.$store.state.quiz.postventa.forEach(item => {
                item.max = parseInt(item.max);
                let object = (item.max - 0.5);
                let percent = ((1 - item.total / object) * 100 * -1).toFixed(2);
                let options = Util.extend(true, {}, this.options);
                let color = (item.total < (item.number == 4 ? 4 : 2) ? 0 : 
                            (item.total < (item.number == 4 ? 9 : 4) ? 1 : 2));

                //color = 2;
                options.thermo.color = this.colors[color];
                options.thermo.backgroundColor = this.colorsBack[color];

                list.push({
                    name: item.name.replace(' (Postventa)', ''),
                    total: item.total,
                    max: item.max,
                    object: object,
                    percent: percent,
                    options: options,
                    color: color,
                });
            });
            return list;
        }

        get loading() {
            return this.$store.state.quiz.loading;
        }

        get colors() {
            return ['#D32F2F', '#FFC107','#43A047'];
        }

        get colorsBack() {
            return ['#FFCDD2', '#FFF9C4', '#C8E6C9'];
        }


        loadData() {
            this.$emit('load-data');
        }

        mounted() {
        }
 }
